export enum EApiBusinessErrorCode {
  AUDIT_PACK_REQUIRED_DOCUMENT_STATUS_NOT_UPLOADED_BY_AUDITOR = 'AUDIT_PACK_REQUIRED_DOCUMENT_STATUS_NOT_UPLOADED_BY_AUDITOR',
  SALES_DOCUMENTS_NOT_READY_FOR_CONFIRMATION = 'SALES_DOCUMENTS_NOT_READY_FOR_CONFIRMATION',
}
